import { render, staticRenderFns } from "./EditorJSComponent.vue?vue&type=template&id=4331f9d4"
import script from "./EditorJSComponent.vue?vue&type=script&lang=js"
export * from "./EditorJSComponent.vue?vue&type=script&lang=js"
import style0 from "./EditorJSComponent.vue?vue&type=style&index=0&id=4331f9d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports